<template>
  <div class="ticheng">
    <breadcrumb :breadcrumbList="breadcrumbList4"></breadcrumb>
    <div class="main-content">
      <list></list>
    </div>
  </div>
</template>

<script lang="js">
import { defineComponent, reactive, ref } from 'vue'
import topContent from '../base-ui/top-content/top-content.vue'
import list from '../base-ui/list4/list.vue'
import { breadcrumbList4 } from '../config'
import Breadcrumb from '@/components/breadcrumb/breadcrumb.vue'

export default defineComponent({
  props: {

  },
  components: {
    topContent,
    list,
    Breadcrumb
  },
  setup() {


    return {
      breadcrumbList4
    }

  }
})
</script>

<style scoped lang="less">
.ticheng {
  min-width: 1080px;

  .main-content {
    padding: 20px;
    margin: 20px;
    background-color: #fff;
  }
}
</style>
